import AppVars from '@/enums/appVars';

const trackingApi = (domain: string | undefined) => ({
  ClientEvent: `${domain}/client-event`,
  ClientEvents: `${domain}/client-events`,
  ClientIdentifier: `${domain}/identity`,
});

export default trackingApi(AppVars.TrackApi);
